export default __webpack_public_path__ + "static/media/lapis_project.2e054ff3.png";